import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Modal, Button, Form, Table, Alert } from "react-bootstrap";
import axios from "axios";
import WeekSelector from "../weekSelector";
import DriverSelector from "../../components/driverSelector";
import { useTranslation } from 'react-i18next';
import { AiOutlineEye, AiOutlineDelete, AiOutlineCheckCircle, AiOutlineFolderOpen, AiOutlinePlus } from "react-icons/ai";
import { useLocation } from "react-router-dom";


const DriversDebts = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [selectedWeek, setSelectedWeek] = useState(null);

    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [debts, setDebts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showDriverDebtsModal, setShowDriverDebtsModal] = useState(false);
    const [driverDebtsModalDriverId, setDriverDebtsModalDriverId] = useState(null); // id водія для модалки "всі борги"
    const [debtFilter, setDebtFilter] = useState(null); // null = всі, "open" | "closed" — повторний клік скасовує фільтр
    const currentYear = new Date().getFullYear();
    const [validationError, setValidationError] = useState(null);

    const [newDebt, setNewDebt] = useState({
        driver_id: "",
        week_number: null,
        year: currentYear,
        debt_total: "",
        debt_name: "",
        debt_create_desc: "",
        debt_status: "open",
    });

    const navigate = useNavigate();

    useEffect(() => {
        axios.get("/api/users", { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })
            .then((res) => setUsers(res.data))
            .catch((err) => console.error("Помилка завантаження списку водіїв:", err));
    }, []);

    useEffect(() => {
        let url = selectedUser
            ? `/api/drivers-debts?driver_id=${selectedUser.value}`
            : "/api/drivers-debts";

        console.log("Запит на борги водія:", { url, selectedUser });

        axios.get(url)
            .then((res) => {
                const updatedDebts = res.data.map(debt => {
                    const user = users.find(user => user.id === debt.driver_id);
                    return {
                        ...debt,
                        driver_firstName: user ? user.firstName : "Невідомий",
                        driver_lastName: user ? user.lastName : "Водій",
                    };
                });
                setDebts(updatedDebts);
            })
            .catch((err) => console.error("Помилка завантаження боргів:", err));
    }, [selectedUser, users]); // ✅ Додаємо залежність від `filterOpenDebts`

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const openModal = params.get("openModal");
        const driverId = params.get("driverId");
        const week = params.get("week");
        const sum = params.get("sum");
        const name = params.get("name");
        const desc = params.get("desc");

        if (openModal === "true") {
            setShowModal(true);
        }

        if (driverId) {
            const foundUser = users.find(user => user.id.toString() === driverId);
            if (foundUser) {
                setSelectedUser({ value: foundUser.id, label: `${foundUser.firstName} ${foundUser.lastName}` });
                setNewDebt(prev => ({
                    ...prev,
                    driver_id: foundUser.id,
                }));
            }
        }

        if (week) {
            setNewDebt(prev => ({
                ...prev,
                week_number: week,
            }));
        }

        if (sum || name || desc) {
            setNewDebt(prev => ({
                ...prev,
                debt_total: sum || prev.debt_total,
                debt_name: name || prev.debt_name,
                debt_create_desc: desc || prev.debt_create_desc,
            }));
        }
    }, [location.search, users]);



    const handleSelectDriver = (driver) => {
        if (driver && driver.value) {
            console.log("Обраний водій:", driver);
            setSelectedUser(driver);
        } else {
            console.warn("Помилка: некоректний водій", driver);
            setSelectedUser(null);
        }
    };

    const validateForm = () => {
        if (!newDebt.driver_id) {
            setValidationError(t("chooseDriverAlert"));
            return false;
        }
        if (!newDebt.week_number) {
            setValidationError(t("chooseWeekAlert"));
            return false;
        }
        if (!newDebt.debt_total || parseFloat(newDebt.debt_total) <= 0) {
            setValidationError(t("debtSumAlert"));
            return false;
        }
        if (!newDebt.debt_name.trim()) {
            setValidationError(`${t("emptyAlert")} - ${t("debtTitle")}`);
            return false;
        }
        if (!newDebt.debt_create_desc.trim()) {
            setValidationError(`${t("emptyAlert")} - ${t("description")}`);
            return false;
        }

        setValidationError(null);
        return true;
    };

    const handleCreateDebt = () => {

        if (!validateForm()) return;

        axios.post("/api/drivers-debts", newDebt, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })
            .then(() => {
                setShowModal(false);
                setNewDebt({
                    driver_id: "",
                    week_number: null,
                    year: currentYear,
                    debt_total: "",
                    debt_name: "",
                    debt_create_desc: "",
                    debt_status: "open",
                });
                setSelectedUser(null);


                if (selectedUser) {
                    axios.get(`/api/drivers-debts?driver_id=${selectedUser.value}`)
                        .then((res) => setDebts(res.data));
                }
                navigate("/admin/driver-debts");

            })
            .catch((err) => console.error("Помилка створення боргу:", err));
    };

    const handleDeleteDebt = async (debtId) => {
        const confirm = window.confirm("Ви дійсно хочете видалити цей борг?");
        if (!confirm) return;

        try {
            await axios.delete(`/api/drivers-debts/${debtId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            setDebts(prev => prev.filter(debt => debt.id !== debtId));
        } catch (error) {
            console.error("❌ Помилка при видаленні боргу:", error);
            alert("Не вдалося видалити борг");
        }
    };

    const handleCloseDebt = async (debtId) => {
        const confirm = window.confirm(t("confirmCloseDebt") || "Закрити цей борг?");
        if (!confirm) return;
        try {
            await axios.patch(`/api/drivers-debts/${debtId}`, { debt_status: "closed" }, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            });
            setDebts(prev => prev.map(d => d.id === debtId ? { ...d, debt_status: "closed" } : d));
        } catch (error) {
            console.error("Помилка при закритті боргу:", error);
            alert("Не вдалося закрити борг");
        }
    };


    return (
        <div className="container mt-4">
            <h2>{t("debts")}</h2>

            <Form.Group className="mb-3">
                <DriverSelector selectedDriver={selectedUser} setSelectedDriver={handleSelectDriver} />
            </Form.Group>

            {/* Фільтри: Відкриті борги (червона обводка) / Закриті борги (сіра рамка); повторний клік — показати всі */}
            <div className="d-flex flex-column flex-md-row mb-4" style={{ gap: "8px" }}>
                {[
                    { id: "open", label: t("openDebts"), count: debts.filter(d => d.debt_status !== "closed").length, icon: AiOutlineFolderOpen, borderClass: "border-danger" },
                    { id: "closed", label: t("closedDebts"), count: debts.filter(d => d.debt_status === "closed").length, icon: AiOutlineCheckCircle, borderClass: "border-secondary" },
                ].map(({ id, label, count, icon: Icon, borderClass }) => {
                    const isActive = debtFilter === id;
                    return (
                        <div
                            key={id}
                            className={`border rounded px-3 py-2 d-flex align-items-center justify-content-center gap-2 flex-grow-1 ${borderClass}`}
                            style={{
                                flex: "1 1 0",
                                minWidth: 0,
                                cursor: "pointer",
                                backgroundColor: "#fff",
                                color: "var(--bs-body-color)",
                            }}
                            onClick={() => setDebtFilter(prev => prev === id ? null : id)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === "Enter" && setDebtFilter(prev => prev === id ? null : id)}
                        >
                            <Icon size={20} className="flex-shrink-0" />
                            <span className={isActive ? "fw-bold" : "fw-normal"}>{label}</span>
                            <span className="text-muted" style={{ fontSize: "1rem" }}>{count}</span>
                        </div>
                    );
                })}
            </div>

            <Button variant="primary" className="w-100 d-flex align-items-center justify-content-center gap-2" onClick={() => setShowModal(true)}>
                <AiOutlinePlus size={20} />
                {t("create")}
            </Button>

            <Table striped bordered hover className="mt-3">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>{t("driver")}</th>
                        <th>{t("debt")}</th>
                        <th>{t("debtTitle")}</th>
                        <th>{t("status")}</th>
                        <th>{t("actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {debts
                        .slice()
                        .sort((a, b) => {
                            if (a.debt_status === "closed" && b.debt_status !== "closed") return 1;
                            if (a.debt_status !== "closed" && b.debt_status === "closed") return -1;
                            return 0;
                        })
                        .filter(debt => debtFilter == null ? true : debtFilter === "open" ? debt.debt_status !== "closed" : debt.debt_status === "closed")
                        .map(debt => (
                            <tr
                                key={debt.id}
                                className={debt.debt_status === "closed" ? "table-secondary" : ""}
                            >
                                <td>{debt.id}</td>
                                <td
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setDriverDebtsModalDriverId(debt.driver_id);
                                        setShowDriverDebtsModal(true);
                                    }}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => e.key === "Enter" && (setDriverDebtsModalDriverId(debt.driver_id), setShowDriverDebtsModal(true))}
                                >
                                    {`${debt.driver_firstName} ${debt.driver_lastName}`}
                                </td>
                                <td>{debt.debt_total}</td>
                                <td>{debt.debt_name}</td>
                                <td>
                                    {debt.debt_status === "closed" ? (
                                        <span className="text-muted d-flex align-items-center gap-1">
                                            <AiOutlineCheckCircle size={18} /> {t("closed")}
                                        </span>
                                    ) : (
                                        <span className="d-flex align-items-center gap-1">
                                            <AiOutlineFolderOpen size={18} className="text-warning" /> {t("debtStatusOpen")}
                                        </span>
                                    )}
                                </td>
                                <td>
                                    <span className="d-flex align-items-center gap-2">
                                        <AiOutlineEye
                                            className={debt.debt_status === "closed" ? "text-muted" : "text-primary"}
                                            style={{ cursor: "pointer" }}
                                            size={20}
                                            onClick={() => navigate(`/admin/driver-debts/${debt.id}`)}
                                            title={t("preview")}
                                        />
                                        {debt.debt_status !== "closed" && (
                                            <AiOutlineCheckCircle
                                                className="text-success"
                                                style={{ cursor: "pointer" }}
                                                size={20}
                                                onClick={() => handleCloseDebt(debt.id)}
                                                title={t("closeDebt")}
                                            />
                                        )}
                                        {debt.debt_status === "closed" && (
                                            <AiOutlineDelete
                                                className="text-danger"
                                                style={{ cursor: "pointer" }}
                                                size={20}
                                                onClick={() => handleDeleteDebt(debt.id)}
                                                title={t("delete")}
                                            />
                                        )}
                                    </span>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>



            {/* Модальне вікно для додавання боргу */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("add")} {t("debt").toLocaleLowerCase()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {validationError && <Alert variant="danger">{validationError}</Alert>}
                    <Form>
                        <Form.Group>
                            <Form.Label>{t("driver")}</Form.Label>
                            <DriverSelector
                                selectedDriver={newDebt.driver_id ?
                                    {
                                        value: newDebt.driver_id,
                                        label: users.find(user => user.id === newDebt.driver_id)?.firstName + " " + users.find(user => user.id === newDebt.driver_id)?.lastName
                                    }
                                    : null
                                }
                                setSelectedDriver={(driver) => {
                                    setNewDebt(prevDebt => ({
                                        ...prevDebt,
                                        driver_id: driver ? driver.value : ""
                                    }));
                                }}
                            />
                        </Form.Group>

                        <Form.Group>
                            <WeekSelector
                                selectedWeek={newDebt.week_number}
                                setSelectedWeek={(week) => setNewDebt({ ...newDebt, week_number: week })}
                                className="w-100"
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t("value")}</Form.Label>
                            <Form.Control
                                type="number"
                                value={newDebt.debt_total}
                                onChange={(e) => setNewDebt({ ...newDebt, debt_total: e.target.value })}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t("debtTitle")}</Form.Label>
                            <Form.Control
                                type="text"
                                value={newDebt.debt_name}
                                onChange={(e) => setNewDebt({ ...newDebt, debt_name: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{t("description")}</Form.Label>
                            <Form.Control
                                type="text"
                                value={newDebt.debt_create_desc}
                                onChange={(e) => setNewDebt({ ...newDebt, debt_create_desc: e.target.value })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>{t("close")}</Button>
                    <Button variant="primary" onClick={handleCreateDebt}>{t("add")}</Button>
                </Modal.Footer>
            </Modal>

            {/* Модальне вікно: всі борги водія в хронологічному порядку */}
            <Modal show={showDriverDebtsModal} onHide={() => setShowDriverDebtsModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("debts")} — {driverDebtsModalDriverId != null && (() => {
                            const d = debts.find(debt => debt.driver_id === driverDebtsModalDriverId);
                            return d ? `${d.driver_firstName} ${d.driver_lastName}` : users.find(u => u.id === driverDebtsModalDriverId)?.firstName + " " + users.find(u => u.id === driverDebtsModalDriverId)?.lastName || "";
                        })()}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {driverDebtsModalDriverId != null && (() => {
                        const driverDebtsList = debts
                            .filter(d => d.driver_id === driverDebtsModalDriverId)
                            .sort((a, b) => {
                                const dateA = a.created_at ? new Date(a.created_at) : new Date(a.year || 0, 0, (a.week_number || 0) * 7);
                                const dateB = b.created_at ? new Date(b.created_at) : new Date(b.year || 0, 0, (b.week_number || 0) * 7);
                                return dateB - dateA;
                            });
                        if (driverDebtsList.length === 0) {
                            return <p className="p-4 text-muted mb-0">{t("noRecords")}</p>;
                        }
                        return (
                            <ul className="list-group list-group-flush">
                                {driverDebtsList.map((debt) => (
                                    <li
                                        key={debt.id}
                                        className="list-group-item d-flex align-items-start justify-content-between gap-3 py-3"
                                        style={{ borderLeft: `3px solid ${debt.debt_status === "closed" ? "var(--bs-secondary)" : "var(--bs-danger)"}` }}
                                    >
                                        <div className="d-flex flex-column min-w-0 flex-grow-1">
                                            <Link
                                                to={`/admin/driver-debts/${debt.id}`}
                                                className="fw-semibold text-break text-decoration-none text-dark"
                                                onClick={() => setShowDriverDebtsModal(false)}
                                            >
                                                {debt.debt_name}
                                            </Link>
                                            {(debt.debt_create_desc || debt.week_number != null) && (
                                                <span className="small text-muted mt-1 text-break">
                                                    {debt.week_number != null && `${t("week")} ${debt.week_number}`}
                                                    {debt.week_number != null && debt.debt_create_desc && " · "}
                                                    {debt.debt_create_desc && (debt.debt_create_desc.length > 80 ? debt.debt_create_desc.slice(0, 80) + "…" : debt.debt_create_desc)}
                                                </span>
                                            )}
                                            {debt.created_at && (
                                                <span className="small text-muted mt-1">
                                                    {t("created")}: {new Date(debt.created_at).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" })}
                                                </span>
                                            )}
                                            {debt.debt_status === "closed" && debt.closed_at && (
                                                <span className="small text-muted mt-1 d-block">
                                                    {t("closedAt")}: {new Date(debt.closed_at).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" })}
                                                </span>
                                            )}
                                        </div>
                                        <div className="d-flex align-items-center gap-3 flex-shrink-0">
                                            <span className="fw-bold">{debt.debt_total} PLN</span>
                                            <span className={`badge ${debt.debt_status === "closed" ? "bg-secondary" : "bg-warning text-dark"}`}>
                                                {debt.debt_status === "closed" ? t("closed") : t("debtStatusOpen")}
                                            </span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        );
                    })()}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDriverDebtsModal(false)}>{t("close")}</Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default DriversDebts;
